<template>
  <div class="md-layout"></div>
</template>
<script>
import { logout } from "../utils/auth0";
import api from "@/api";

export default {
  data() {
    return {
      config: api.props.config
    };
  },
  mounted() {
    logout();
  }
};
</script>
